import React from "react";

interface IEmailDisplayProps {
	emailAddress: string;
}

const EmailDisplay: React.FC<IEmailDisplayProps> = ({ emailAddress }) => {
	return (
		<a
			href={`mailto:${emailAddress}`}
			className="text-blue-600 hover:text-orange-500 hover:underline"
		>
			{emailAddress}
		</a>
	);
};

export default EmailDisplay;
